export const getCarouselImagesForAnimationLoop = (state) => {
  const { kioskCarouselImages } = state

  return kioskCarouselImages?.images || []
}

/**
 * Loading State for Carousel Images
 * @param {Object} state
 * @returns {Boolean}
 */
export const isLoadingCarouselImages = (state) => state.kioskCarouselImages?.isLoading || false
